var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.568,
    height: 41.568,
    viewBox: "0 0 41.568 41.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(15.898 10.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M611.917,416.346v10.168a.265.265,0,0,0,.265.265h3.776a.265.265,0,0,0,.265-.265V416.18h2.738a.265.265,0,0,0,.264-.242l.263-3.113a.265.265,0,0,0-.264-.287h-3v-2.209a.937.937,0,0,1,.937-.937h2.11a.265.265,0,0,0,.265-.265v-3.113a.265.265,0,0,0-.265-.265H615.7a3.788,3.788,0,0,0-3.788,3.788v3h-1.888a.265.265,0,0,0-.265.265v3.113a.265.265,0,0,0,.265.265h1.888Z",
    transform: "translate(-609.764 -405.747)",
    fill: "#17447e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M601.885,387.236A20.784,20.784,0,1,0,622.67,408.02,20.807,20.807,0,0,0,601.885,387.236ZM620,408.02A18.119,18.119,0,1,1,601.885,389.9,18.139,18.139,0,0,1,620,408.02Z",
    transform: "translate(-581.102 -387.236)",
    fill: "#17447e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fbIcon.8295c2fd65c44e4f8ca5e83051a3e1d9.svg";
export { ForwardRef as ReactComponent };